module.exports = __webpack_public_path__ + "img/slash-divider.acbf2624.svg";